import React from 'react';
import PropTypes from 'prop-types';
import Root from '../../routes';
import styles from './styles.module.scss';

function App({currentLocale}) {

  const contentDirection = (currentLocale === 'he') ? 'rtl' : 'ltr';

  return (
    <div dir={contentDirection} className={styles.appContainer}>
      <Root/>
    </div>
  );
}

App.propTypes = {
  currentLocale: PropTypes.string,
};

export default App;
